module.exports = __webpack_public_path__ + "img/hr-V-R-2-unload-connect-shadow.0a17a956.png";